import React, { Component } from 'react';

import comingSoonConfig from '../../config/coming-soon.json';

import $ from 'jquery';

class AerialPhotograph extends Component {

  constructor(props) {
    super(props);

    this.state = {
      ...this.props
    }
  }
  
  componentWillMount() {
    
  }

  componentDidMount() {
    let t = this;

    const toFunc = function(){
      console.log('polling t.props.data...')
      if (typeof t.props.data !== 'undefined') {
        t.setState({
          data: t.props.data
        });
      } else {
        t.t0 = setTimeout(toFunc, 500);
      }
    }

    this.t0 = setTimeout(toFunc, 500);
    
    t.pageLoad();

    this.changePositioning();
    this.props.updateLang();
    window.addEventListener('resize', this.changePositioning);
    $( ".mobile-main-page-bg" ).on('load', function() {
      $('.mobile-main-page-content-container').css({
        'top': (t.props.lang == 'en' ? '49%' : '52.5%'),
        'left': (t.props.lang == 'en' ? '11.5%' : '10.5%'),
      })
    });

    let updateItemList = setInterval(function() {
      $('.mobile-main-page-content-container').css({
        'top': (t.props.lang == 'en' ? '49%' : '52.5%'),
        'left': (t.props.lang == 'en' ? '11.5%' : '10.5%'),
      })
    }, 100)

    setTimeout(function(){
      clearInterval(updateItemList)
    }, 4000)
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.changePositioning);

    clearTimeout(this.t0);
  }

  pageLoad () {
    let t = this;
    t.props.bgImageOnload();
  }

  changePositioning() {
    let t = this;
    setTimeout(function(){
      $('.mobile-main-page').css({
        'height': $('.mobile-main-page-bg').css('height')
      })
    }, 500)
    setTimeout(function(){
      $('.mobile-main-page').css({
        'height': $('.mobile-main-page-bg').css('height')
      })
    }, 1000)
    setTimeout(function(){
      $('.mobile-main-page').css({
        'height': $('.mobile-main-page-bg').css('height')
      })
    }, 1500)
  }
  
  render() {
    let t = this;
    return <div className='mobile-main-page-container' style={{}}>
      <div className='mobile-main-page' style={{}}>
        <img className='mobile-main-page-bg' src={'/p2/mobile/page/' + this.props.lang + '/aerial-photograph.png'} style={{
          'minWidth': '100%',
          'width': '100%'
        }}/>

        <div className='mobile-main-page-content-container' style={{
          'top': (t.props.lang == 'en' ? '49%' : '52.5%'),
          'left': (t.props.lang == 'en' ? '11.5%' : '10.5%'),
          'width': '66%',
          'height': '90px',
          'overflow': 'scroll'
        }}>
          {this.state.data && this.state.data.aerial_photograph && this.state.data.aerial_photograph.length > 0 ?
            this.state.data.aerial_photograph.map(function(elem, idx){
              return <a className='item-button' key={idx} href={elem.url} target='_blank' style={{

                }}>
                <div className={(t.props.lang == 'en' ? 'item-is-eng' : 'item-is-chi')} style={{
                  'padding': '6px 0',
                  'textShadow': '2px 2px 3px #000, 1px 1px 1px #000, 3px 3px 3px #000'
                }}>
                  {elem[t.props.lang]}
                </div>
              </a>
            }) : <div style={{
              'color': 'white',
              'padding': '6px 0',
              'textShadow': '2px 2px 3px #000, 1px 1px 1px #000, 3px 3px 3px #000'
            }}>{comingSoonConfig[t.state.lang]}</div>
          }
        </div>
      </div>
    </div>
  }

};

export default AerialPhotograph;



// WEBPACK FOOTER //
// ./src/mobile/page/AerialPhotograph.js